import { render } from "./CardLoader.vue?vue&type=template&id=5bda2898&scoped=true"
import script from "./CardLoader.vue?vue&type=script&lang=js"
export * from "./CardLoader.vue?vue&type=script&lang=js"

import "./CardLoader.vue?vue&type=style&index=0&id=5bda2898&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\HolyHeart\\presi\\studentapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bda2898"]])

export default __exports__